<template>
    <a-locale-provider :locale="zh_CN">
        <div class="pages-container">

            <!--在线留言-->
            <OnlineMsg v-show="showMsg"/>
            <transition name="fade">
                <router-view/>
            </transition>
            <vue-progress-bar></vue-progress-bar>
            <a-modal v-model="modelState" :closable="false" footer="" class="certification" :maskClosable="false"
                     :afterClose="afterClose" width="1000px">
                <!--<div style="display: flex; flex-direction: column; text-align: left;margin-bottom: 60px;">
                  <h1 style="margin: 0px auto">用户涉企金融信用信息数据授权协议</h1>
                  <p style="font-weight: bold;line-height: 40px">一、概述</p>
                  <p style="font-size: 14px;text-indent:28px">本协议（以下简称“本协议”）是长沙市金融综合服务平台（以下简称“本平台”）与用户（以下或称为“您”）就本平台融资服务（以下简称“本服务”）过程中的授权事宜所订立的有效合约。</p>
                  <p style="font-size: 14px;text-indent:28px">您通过网络页面点击确认或以其他方式选择接受本协议，即表示您与本平台已达成协议并同意接受本协议的全部约定内容。</p>
                  <p style="font-size: 14px;text-indent:28px">本平台提醒您认真阅读、充分理解本规则各条款，特别是其中与您的权益有或可能具有重大关系的条款，及对本平台具有或可能具有免责或限制责任的条款（尤其是粗体下划线标注部分）。<span style="font-size: 14px;font-weight: bold;text-decoration:underline">如您不同意接受本协议的任意内容，或者无法准确理解相关条款含义的，请不要进行后续操作。</span></p>
                  <p style="font-weight: bold;line-height: 40px">二、定义</p>
                  <p style="font-size: 14px;text-indent:28px">2.1 政府部门：指由长沙市发展和改革委员会主办提供平台服务、信息展示等服务的平台。</p>
                  <p style="font-size: 14px;text-indent:28px">2.2 金融机构：指入驻本平台的银行、信保公司、保险公司，经本平台撮合，在本平台发布产品信息，向法人或其他组织提供金融服务的金融机构。</p>
                  <p style="font-size: 14px;text-indent:28px">2.3 企业：指注册或通过本平台向金融机构方申请服务的法人或其他组织。</p>
                  <p style="font-weight: bold;line-height: 40px">三、授权条款</p>
                  <p style="font-size: 14px;text-indent:28px;font-weight: bold;text-decoration:underline">3.1 您授权本平台及其关联平台采集、查询、验证、打印、使用您的信息（包括但不限于公共信用信息和包括信贷信息在内的涉企金融信用信息、企业财务、税务信息等，但法律、法规、监管政策禁止的除外），并在本授权签署之日至约定用途的业务结清之日期间将您的全部/部分信息向您选择的金融机构服务方、企业征信机构服务方提供，该等信息为金融机构、企业征信机构为提供服务所需。</p>
                  <p style="font-size: 14px;text-indent:28px;font-weight: bold;text-decoration:underline">3.2 您授权本平台在您使用本服务期间或本服务终止后，基于政府对融资对接监管、报表统计需要，本平台有权保留并使用您在使用本服务期间所形成的相关信息数据（包括您选择的金融机构服务方合法收集、保存的您的相关信息），并提供给本平台之关联平台。</p>
                  <p style="font-size: 14px;text-indent:28px;font-weight: bold;text-decoration:underline">3.3 您同意本协议中的授权不可变更、撤回或撤销。</p>
                  <p style="font-weight: bold;line-height: 40px;">四、其他条款</p>
                  <p style="font-size: 14px;text-indent:28px">4.1 您同意，本平台有权随时对本协议内容进行单方面的变更，并在本平台公告通知您；若您在本协议内容变更生效后继续本平台服务的，表示您已充分阅读、理解并接受变更修改后的协议内容，也将遵循变更修改后的协议内容。</p>
                  <p style="font-size: 14px;text-indent:28px;font-weight: bold;text-decoration:underline">4.2 本平台重视对用户隐私的保护。除本协议约定外，本平台将按照相关隐私权政策保护您的身份信息和其他个人信息。</p>
                  <p style="font-size: 14px;text-indent:28px;font-weight: bold;text-decoration:underline">4.3 双方在履行本协议的过程中，如发生争议，应协商解决。协商不成的，任何一方均应向本平台所在地有管辖权的人民法院提起诉讼。</p>
    &lt;!&ndash;              <p style="font-size: 14px;text-indent:28px;font-weight: bold;text-decoration:underline">4.4信贷信息提供给政府部门。</p>&ndash;&gt;
                </div>-->
                <div style="display: flex; flex-direction: column; text-align: left;margin-bottom: 60px;">
                    <div id="title" style="margin-bottom: 3px;">
                        <h1 style="text-align: center;margin: 0px auto">
                            <p style="font-size: 30px;display: inline-block;">
                                {{titleName}}
                            </p>
                        </h1>
                    </div>
                    <div style="width: 800px;margin-left: auto;margin-right: auto;">
                        <p>
                            <span v-html="editContent"></span>
                        </p>
                    </div>
                </div>
                <div
                        :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'center'
                    }"
                >
                    <a-button @click="out" style="width: 40%;">不同意，退出登录</a-button>
                    <a-button @click="certified" type="primary" style="margin-left: 10%;width: 40%;"
                              :disabled="disabled">{{buttontext}}
                    </a-button>
                </div>
            </a-modal>

            <a-modal v-model="showStreet" title="当前账号未选择街道，请提交之后继续使用" :closable="false" footer="" class="certification" :maskClosable="false"
                     :afterClose="afterClose" width="400px">
                <a-form :form="companyform">
                    <a-form-item label="主体名称">
                        <span>{{companyData.companyName}}</span>
                    </a-form-item>
                    <a-form-item label="统一社会信用代码">
                        <span>{{companyData.socialCreditUnicode}}</span>
                    </a-form-item>
                    <a-form-item label="所属街道">
                        <a-cascader :options="streetOptions" placeholder="请选择所属街道" @change="onChange"
                                    v-decorator="[
                                        'street',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择所属街道!'
                                                }
                                            ]
                                        }
                                    ]"
                        />
                    </a-form-item>
                    <a-button type="primary" style="position: absolute;right: 25px;bottom: 10px;" :loading="streetLoading" @click="subStreet">提交</a-button>
                </a-form>
            </a-modal>
        </div>

    </a-locale-provider>
</template>

<script>
    import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
    import {getCompanyInfo,insertCompany} from "@/api/company/company";
    import {userStatus} from "@/api/user";
    import {getEnableLoginAgreement} from "@/api/loginAgreement/loginAgreement"
    import {Certification, certify} from "@/api/yhgl/account";
    import {mapGetters} from "vuex";
    import OnlineMsg from "@/components/onlineMessage/OnlineMessage";
    import {findAreaChildren} from "@/api/yhgl/regions";

    export default {
        components: {
            OnlineMsg
        },
        name: "app",
        computed: {
            ...mapGetters(["storeAccount"])
        },
        data() {
            return {
                zh_CN,
                show: false,
                showMsg: false,
                modelState: false,
                showStreet: false,
                streetLoading: false,
                disabled: true,
                cerflag: true,
                time: 10,
                buttontext: "同意上述协议",
                titleName: "",
                companyform: this.$form.createForm(this),
                companyData: [],
                streetList: [],
                streetOptions: [],
                street: "",
                editContent: ""

            };
        },
        created() {
            this.$Progress.start();
        },
        watch: {
            $route(to) {
              // console.log("=========");
              // console.log(this.$route);
              // if (this._isMobile()&&to.path.indexOf("prompt")<0) {
              //   // console.log("移动端")
              //   window.location.href = "http://jrcs.wangcheng.gov.cn:8090/mobile/";
              // }
                this.initSlider();
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.initSlider();
            });
        },
        methods: {
            /**
             * 初始化时配置菜单选择
             */
            initSlider() {
                if(this.storeAccount.roleId == "1025"){
                    this.showMsg = true;
                }
                //判断当前用户是否需要实名认证
                if (this.storeAccount.roleId == "1025" && this.storeAccount.certification == 0) {
                    this.modelState = true;
                    getEnableLoginAgreement().then(resp => {
                        if (resp.data.success == "TRUE") {
                            this.titleName = resp.data.data.result.title;
                            this.editContent = resp.data.data.result.content;
                        }
                    }).catch(() => this.$message.error("服务器异常，请稍后再试！"))
                    this.timer();
                }
                if(this.storeAccount.roleId == "1025" && this.storeAccount.idCard){
                    getCompanyInfo(this.storeAccount.idCard).then(res=>{
                        if(res.data.success == 'TRUE'){
                            let data = res.data.data.company;
                            this.companyData = data;
                            let isNull = [undefined, null, ""];
                            if (data && isNull.includes(data.street)) {
                                this.showStreet = true;
                                this.initStreetList();
                            }
                        }
                    })
                }
            },
            initStreetList(){
                findAreaChildren().then(res=>{
                    if(res.data.success == "TRUE"){
                        this.streetList = res.data.data.regions;
                        res.data.data.regions.forEach(item=>{
                            this.streetOptions.push({
                                label: item.name,
                                value: item.code,
                                children: item.children.map(it=>{
                                    return {
                                        label: it.name,
                                        value: it.code
                                    }
                                })
                            })
                        })
                    }
                })
            },
            subStreet(){
                this.companyform.validateFields((err, value) => {
                    if (!err) {
                        if(this.street){
                            this.streetLoading = true;
                            let data = {
                                id: this.companyData.id,
                                type: 'update',
                                street: this.street
                            };
                            insertCompany(data).then(res=>{
                                this.streetLoading = false;
                                if(res.data.success == "TRUE"){
                                    this.showStreet = false;
                                    this.$message.success("提交成功！");
                                }
                            }).catch(()=>{
                                this.streetLoading = false;
                                this.$message.error("提交失败，服务器异常，请联系管理员！");
                            })
                        }else {
                            this.$message.warn("未获取到选中参数，请尝试刷新页面重新选择")
                        }
                    }
                });
            },
            onChange(value){
                if(value.length > 0){
                    this.street = value[1];
                }
            },
            out() {
                this.$store.commit("clearAccount");
                window.location.href = "https://auth.zwfw.hunan.gov.cn/oauth2/logout?client_id=TPoDVeQpSAi8Al4NUhSZgg&response_type=code&redirect_uri=http://fgw.changsha.gov.cn/xycs/xydapi/unifyLogin/logout";
            },
            afterClose() {
                Certification().then(res => {
                    if (res.data.success != "TRUE") {
                        this.modelState = true;
                    }
                });
            },
            certified() {
                //后端进行实名认证
                certify().then(res => {
                    if (res.data.success == "TRUE") {
                        this.$message.info("协议签署成功！")
                        this.modelState = false;
                    }
                });
            },
            timer() {
                if (this.time == 0) {
                    this.disabled = false;
                    this.buttontext = "同意上述协议";
                    this.time = 10;
                } else {
                    this.disabled = true;
                    this.buttontext = "同意上述协议(" + this.time + ")";
                    this.time--;
                    setTimeout(() => {
                        this.timer()
                    }, 1000)
                }
            },
            _isMobile() {

                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                // console.log(navigator.userAgent);
                return flag;
            },
        },
        mounted() {


                // console.log("web端");
                // window.location.href = "http://fgw.changsha.gov.cn/xycs/xyd/index";
                this.$Progress.finish();
                this.$router.beforeEach((to, from, next) => {
                    this.$Progress.start();
                    if (to.meta.login) {
                        //需要登录的情况下判断是否有这个权限访问这个页面
                        let status = false;
                        if (to.meta.authorize) {
                            status = this.$store.state.loginMenus.some(menu => {
                                return to.name === "new" || menu === to.name;
                            });
                            if (!status) {
                                this.$message.error("您无权查看此页面").then(() => {
                                    // this.$router.push({ name: "sm_index" });
                                });
                                this.$Progress.finish();
                                return false;
                            }
                        }

                        userStatus().then(res => {
                            if (res.data.success === "TRUE" && res.data.data.account) {
                                document.title = this.$store.getters.systemName.value;
                                this.$store.commit("setAccount", res.data.data.account);
                                next();
                            } else {
                                this.$store.commit("clearAccount");
                                this.$router.push({name: "index"});
                            }
                        });
                        this.$Progress.finish();
                    } else {
                        if (to.meta.title) {
                            document.title = this.$store.getters.systemName.value;
                        }
                        this.$Progress.finish();
                        next();
                    }
                });
                this.$router.afterEach(() => {
                    this.$Progress.finish();
                });

        }
    };
</script>
<style scoped>
    .pages-container {
        height: 97%;
        min-height: 600px;
    }
</style>
